import React from "react";
import { Text } from "@chakra-ui/react";
import { Users } from "lucide-react";
import InfoCard from "../InfoCard";
import EditButton from "../EditButton";

type AboutSectionProps = {
  about: string;
  isOwnProfile: boolean;
  onEdit: () => void;
};

const AboutSection: React.FC<AboutSectionProps> = ({ about, isOwnProfile, onEdit }) => (
  <InfoCard
    title="About"
    icon={<Users size={18} />}
    rightSlot={isOwnProfile ? <EditButton onClick={onEdit} /> : null}
  >
    <Text color="#2b1b1a" fontSize="sm" whiteSpace="pre-wrap">
      {about.trim() || "—"}
    </Text>
  </InfoCard>
);

export default AboutSection;
